import React from 'react'
import { Box } from '@mui/material'
import { AppButtonIcon } from '@components'
import useMultipleActions from 'Pages/Admin/AdminMapping/Table/@hooks/useMultiple'
import { LoadingIconSeeker } from '@ui-seeker/core'


export default function AdminMappingToolbarSelect({ selectedData, setSelectedRows, path }) {
	const { handleRemoveMultipleMappings, isLoadingDelete } = useMultipleActions(selectedData, setSelectedRows, path)

	return <Box sx={{ display: "flex", alignItems: "center", justifyContent: "flex-end", mr: 2.5 }}>
		{!!isLoadingDelete && <LoadingIconSeeker/>}
		{!isLoadingDelete && <AppButtonIcon
			icon="trash"
			iconWeight="solid"
			sx={{ color: "error.main" }}
			tooltip="Delete multiple mappings"
			onClick={handleRemoveMultipleMappings}
		/>}
	</Box>
}